import { createContext, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from './useLocalStorage';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage('user', null);
    const navigate = useNavigate();

    const login = (data) => {
        setUser(data);
        navigate('/', { replace: true });
    };
    const setToken = (token) => {
        user.token = token;
        setUser(user);
    };
    const getToken = () => {
        return user?.token;
    };
    const logout = () => {
        window.localStorage.removeItem('user');
        navigate('/login', { replace: true });
    };
    const handleUserData = (data) => {
        setUser({ ...user, bookings_config: data?.bookings_config });
    };

    const value = useMemo(
        () => ({
            user,
            login,
            logout,
            getToken,
            setToken,
            handleUserData
        }),
        [user]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};
